import * as React from 'react';
import { Radio } from '../Radio/Radio';


var RadioSelect = React.memo(function (_a) {
    var options = _a.options, value = _a.value, className = _a.className, onChange = _a.onChange, disabled = _a.disabled, name = _a.name;
    var isLastElement = function (index) { return index + 1 >= options.length; };
    var classNames = ['pluggy', 'RadioSelect'];
    if (className) {
        classNames.push(className);
    }
    if (disabled) {
        classNames.push('disabled');
    }
    var combinedClassNames = classNames.join(' ');
    var handleOptionClick = React.useCallback(function (_a) {
        var value = _a.value;
        if (disabled || !onChange) {
            return;
        }
        onChange({ name: name, value: value });
    }, [onChange, name, disabled]);
    return (React.createElement("div", { className: combinedClassNames }, options.map(function (option, index) { return (React.createElement("div", { className: 'option-row' },
        React.createElement("div", { onClick: function () { return handleOptionClick(option); }, className: 'option-container' },
            React.createElement("div", { className: 'option-radio' },
                React.createElement(Radio, { checked: value === option.value || options.length === 1, type: 'radio', disabled: disabled })),
            React.createElement("p", { className: 'option-text' }, option.label)),
        !isLastElement(index) && React.createElement("div", { className: 'option-divider' }))); })));
});
export { RadioSelect };
